import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import AbstractCustomCountToggleControl from "../abstract/abstract-custom-count-toggle-control";

export default class CustomSingleWinLimitToggleControl extends AbstractCustomCountToggleControl implements Control {

    public updateOptions(options: ControlOptions) {
        if (!options.customSingleWinLimitSelected) {
            this.setSelected(false);
        }
    }

    protected customOnHandler() {
        super.customOnHandler();

        const options = new ControlOptions();

        options.customSingleWinLimitSelected = false;

        this.onChange.dispatch(options);
    }

    protected customOffHandler() {
        super.customOffHandler();

        const options = new ControlOptions();

        options.customSingleWinLimitSelected = true;

        this.onChange.dispatch(options);

    }
}
